module.exports = __webpack_public_path__ + "media/images/menu/antlia-b507ee1e24a2ea8532b1d2104e683633.jpg";